import { lazy } from 'react';

function lazyNamed(loader, exportName) {
  return lazy(() => loader().then((mod) => ({ default: mod[exportName] })));
}

export const DashboardPage = lazyNamed(() => import('./pages/DashboardPage'), 'DashboardPage');
export const FinancialPage = lazyNamed(() => import('./pages/FinancialPage'), 'FinancialPage');
export const FtdReportPage = lazyNamed(() => import('./pages/FtdReportPage'), 'FtdReportPage');
export const AffiliatorReportPage = lazyNamed(() => import('./pages/AffiliatorReportPage'), 'AffiliatorReportPage');
export const TopWinnersPage = lazyNamed(() => import('./pages/TopWinnersPage'), 'TopWinnersPage');
export const TopLosersPage = lazyNamed(() => import('./pages/TopLosersPage'), 'TopLosersPage');
export const IpAnalysisPage = lazyNamed(() => import('./pages/IpAnalysisPage'), 'IpAnalysisPage');
export const GeriDonenlerPage = lazyNamed(() => import('./pages/GeriDonenlerPage'), 'GeriDonenlerPage');
export const BirthdaysPage = lazyNamed(() => import('./pages/BirthdaysPage'), 'BirthdaysPage');
export const UploadPage = lazyNamed(() => import('./pages/UploadPage'), 'UploadPage');
export const MonthlyGrowthPage = lazyNamed(() => import('./pages/MonthlyGrowthPage'), 'MonthlyGrowthPage');
export const CohortRetentionPage = lazyNamed(
  () => import('./pages/CohortRetentionPage'),
  'CohortRetentionPage'
);
export const CasinoDashboardPage = lazyNamed(() => import('./pages/CasinoDashboardPage'), 'CasinoDashboardPage');
export const SportsbookReportPage = lazyNamed(() => import('./pages/SportsbookReportPage'), 'SportsbookReportPage');
export const FreeSpinDashboardPage = lazyNamed(
  () => import('./pages/FreeSpinDashboardPage'),
  'FreeSpinDashboardPage'
);
export const PlayerBonusesPage = lazyNamed(() => import('./pages/PlayerBonusesPage'), 'PlayerBonusesPage');
export const MemberTrackingPage = lazyNamed(() => import('./pages/MemberTrackingPage'), 'MemberTrackingPage');
export const AbuseTimelinePage = lazyNamed(() => import('./pages/AbuseTimelinePage'), 'AbuseTimelinePage');
export const FraudRiskPage = lazyNamed(() => import('./pages/FraudRiskPage'), 'FraudRiskPage');
export const CustomerRiskPage = lazyNamed(() => import('./pages/CustomerRiskPage'), 'CustomerRiskPage');
export const CustomerRiskProfilePage = lazyNamed(
  () => import('./pages/CustomerRiskProfilePage'),
  'CustomerRiskProfilePage'
);
export const GgrPlayerCasinoPage = lazyNamed(() => import('./pages/GgrPlayerCasinoPage'), 'GgrPlayerCasinoPage');
export const GgrProviderPage = lazyNamed(() => import('./pages/GgrProviderPage'), 'GgrProviderPage');
export const GgrGamePage = lazyNamed(() => import('./pages/GgrGamePage'), 'GgrGamePage');
export const FaturaPage = lazyNamed(() => import('./pages/FaturaPage'), 'FaturaPage');
export const DiscountReportPage = lazyNamed(() => import('./pages/DiscountReportPage'), 'DiscountReportPage');
export const PaymentCommissionPage = lazyNamed(
  () => import('./pages/PaymentCommissionPage'),
  'PaymentCommissionPage'
);
export const KasaPage = lazyNamed(() => import('./pages/KasaPage'), 'KasaPage');
export const WithdrawOpsPage = lazyNamed(() => import('./pages/WithdrawOpsPage'), 'WithdrawOpsPage');
export const OzelOranPage = lazyNamed(() => import('./pages/OzelOranPage'), 'OzelOranPage');
export const CorrectionReportPage = lazyNamed(
  () => import('./pages/CorrectionReportPage'),
  'CorrectionReportPage'
);
export const TelegramSettingsPage = lazyNamed(
  () => import('./pages/TelegramSettingsPage'),
  'TelegramSettingsPage'
);
export const AiSettingsPage = lazyNamed(() => import('./pages/AiSettingsPage'), 'AiSettingsPage');
export const UserManagementPage = lazyNamed(
  () => import('./pages/UserManagementPage'),
  'UserManagementPage'
);
export const RoleManagementPage = lazyNamed(
  () => import('./pages/RoleManagementPage'),
  'RoleManagementPage'
);
export const AccountSettings = lazyNamed(() => import('./components/AccountSettings'), 'AccountSettings');
export const ExtensionPlaceholderPage = lazyNamed(
  () => import('./pages/ExtensionPlaceholderPage'),
  'ExtensionPlaceholderPage'
);
